import { useEffect, useRef } from 'react';
import { User as FirebaseUser, getIdToken } from 'firebase/auth';

interface UseSessionManagerProps {
  user: FirebaseUser | null;
}

export const useSessionManager = ({ user }: UseSessionManagerProps) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (user) {
      const refreshToken = async () => {
        try {
          await getIdToken(user, true);
          if (timeoutRef.current) clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(refreshToken, 45 * 60 * 1000);
        } catch (error) {
          if (timeoutRef.current) clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(refreshToken, 5 * 60 * 1000);
        }
      };

      refreshToken();
      intervalRef.current = setInterval(refreshToken, 45 * 60 * 1000);

      return () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    } else {
      if (intervalRef.current) { clearInterval(intervalRef.current); intervalRef.current = null; }
      if (timeoutRef.current) { clearTimeout(timeoutRef.current); timeoutRef.current = null; }
    }
  }, [user]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
};

